import "./index.scss";

import { Alert, AlertTitle } from "@mui/material";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import StyledButton from "components/shared/StyledButton";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "store/store";
import { createAnalyticalCode } from "store/titleStore";

interface INewAnalyticalCode {
    companyId?: number;
    onClose: () => void;
    /**
     * Create analytical code function
     */
    onCreate: (name: string) => void;
}

interface ICode {
    name: string;
}

const NewAnalyticalCode = ({ companyId, onClose, onCreate }: INewAnalyticalCode) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const {
        control,
        watch,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: "",
        },
        mode: "all",
    });

    const code = watch("name");

    const onSubmit = (data: ICode) => {
        const req = { companyId: companyId, name: data.name };
        dispatch(createAnalyticalCode(req)).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                onCreate(data.name);
                onClose();
            }
        });
    };

    return (
        <div className="new-code-modal">
            <Alert severity="info">
                <AlertTitle>{t("AnalyticalCode.NewCodeCreate")}</AlertTitle>
                {t("AnalyticalCode.ModifyCodeInfo")}
            </Alert>
            <form className="new-code-form" onSubmit={handleSubmit(onSubmit)}>
                <TextFormComponent
                    label={t("AnalyticalCode.AddAnalyticalCode")}
                    control={control}
                    controlName="name"
                    placeholder=""
                    error={errors.name}
                />
                <StyledButton
                    sx={{ marginTop: "24px" }}
                    buttonType="primary"
                    type="submit"
                    disabled={code.length === 0}
                    fullWidth
                >
                    {t("ConnectTitle.Save")}
                </StyledButton>
            </form>
        </div>
    );
};

export default NewAnalyticalCode;
